import { Component, OnInit }				from '@angular/core';
import { Router, ActivatedRoute }			from '@angular/router';
import { ServiceOffersService }				from '../../_services/serviceoffers.service';
import { CustomersService }					from '../../_services/customers.service';
import { AgreementsService }				from '../../_services/agreements.service';
import { StatisticsService }				from '../../_services/statistics.service';
import { ServiceAddonsService }				from '../../_services/serviceaddons.service';
import { Agreement }						from '../../_models/agreement';
import { Http }								from '@angular/http';
import { ServiceOffer }						from '../../_models/serviceoffer';
import { ServiceAddon }						from '../../_models/serviceaddon';
import { StatisticEvent }					from '../../_models/statisticevent';
import { Customer }							from '../../_models/customer';
import { NgbModal, ModalDismissReasons }	from '@ng-bootstrap/ng-bootstrap';
import { Subscription } 					from 'rxjs';
import { ToasterModule,
         ToasterService,
  ToasterConfig
} from 'angular2-toaster/angular2-toaster';
import { CookieModule, CookieService, CookieOptions } from 'ngx-cookie';
import { Car } from 'app/_models/car';

@Component({
	selector: 'app-findcar',
	templateUrl: './findcar.component.html',
	providers: [ServiceOffersService,ServiceAddonsService,CustomersService,AgreementsService,StatisticsService, CookieModule]
})
export class FindCarComponent implements OnInit {
  private serviceoffers: ServiceOffer[];
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  private statisticsService: StatisticsService;
  public hasResponded: boolean = false;

  //private carid: string = '583ac52f778e3d3bd875047a';
  private customerid: string = "";
  private errorMessage: string = "";
  private isLoading: boolean = true;
  private calcStartupCost: boolean = true;

  public kmSelected: number = 15000;
  public yearSelected: number = 5;
  public optin: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist = [];
  private carname: string = "";
  private payment_method: string = "";
  public startupPrice: number = 0;
  public agree: Agreement;
  private subscription: Subscription;
  private service_price: number;

  public options: any = {
    yearStep: [],
    kmStep: [],
  };
  // yearStep: [3, 4, 5],
  // kmStep: [10000,15000,20000,25000,30000]

  private toasterService: ToasterService;
  private cookieService: CookieService;
    public toasterconfig : ToasterConfig =
        new ToasterConfig({
            tapToDismiss: true,
            timeout: 5000
        });

  constructor(toasterService: ToasterService, statisticsService: StatisticsService, private agreementsService: AgreementsService, private customersService: CustomersService, private activatedRoute: ActivatedRoute, private router: Router, private serviceAddonsService: ServiceAddonsService, private serviceoffersService: ServiceOffersService, private modalService: NgbModal, cookieService: CookieService) {
		this.toasterService = toasterService;
    this.statisticsService = statisticsService;
    this.cookieService = cookieService;
    }

  ngOnInit() {
    
    	this.isLoading = true;
      
		// subscribe to router event
		this.subscription = this.activatedRoute.queryParams.subscribe(
			(param: any) => {
				this.customerid = param["cust"];
				this.customersService
					.read(this.customerid)
					.subscribe(
						/* happy path */ p => this.customer = p,
						/* error path */ e => this.errorMessage = e,
						/* onComplete */ () => {
							let statisticEvent:StatisticEvent = new StatisticEvent();
							statisticEvent.customer = this.customer._id;
							statisticEvent.event = "dealer_landingpage_visit";
							this.payment_method=this.customer.dealer[0].payment_method;
							console.log(this.payment_method+" this.payment_method");
						    this.statisticsService
						        .sendEvent(statisticEvent)
						        .subscribe(
						           /* happy path */ r => {console.log('landingpage visit event tracked');},
						           /* error path */ e => {this.errorMessage = e});

            this.carname =
              (this.customer.car as Car).carmake +
              " " +
              (this.customer.car as Car).carmodel +
              " " +
              (this.customer.car as Car).carversion;
            //this.carname='';

            // subscribe to router event
            this.serviceoffersService.getByCar((this.customer.car as Car)._id).subscribe(
              /* happy path */ (p) => (this.serviceoffers = p),
              /* error path */ (e) => (this.errorMessage = e),
              /* onComplete */ () => {
                for (var i = 0; i < this.serviceoffers.length; ++i) {
                  let singleOffer: ServiceOffer = this.serviceoffers[i];
                  let year: number = singleOffer.years;
                  let km: number = singleOffer.km / singleOffer.years;

                  if (!(this.options.yearStep.indexOf(year) > -1)) {
                    this.options.yearStep.push(year);
                  }
                  if (!(this.options.kmStep.indexOf(km) > -1)) {
                    this.options.kmStep.push(km);
                  }
                }

                this.serviceAddonsService
                  .getDealer(this.customer.dealer[0]._id, "guarantee")
                  .subscribe(
                    /* happy path */ (p) => (this.serviceaddons = p),
                    /* error path */ (e) => (this.errorMessage = e),
                    /* onComplete */ () => {
                      for (var i = 0; i < this.serviceaddons.length; i++) {
                        this.serviceaddons[i].selected = true;
                      }
                      this.calculatePrice();
                      this.isLoading = false;
                    }
                  );
              }
            );
          }
        );
      }
    );
  }

  updatePrice() {
    let statisticEvent: StatisticEvent = new StatisticEvent();
    statisticEvent.customer = this.customer._id;
    statisticEvent.event = "dealer_landingpage_calculator";

    this.statisticsService.sendEvent(statisticEvent).subscribe(
      /* happy path */ (r) => {
        console.log("landingpage calculator event tracked");
      },
      /* error path */ (e) => {
        this.errorMessage = e;
        this.isLoading = false;
      }
    );

    this.calculatePrice();
  }

  calculatePrice() {
    let years: number = this.yearSelected;
    let totalKM: number = this.yearSelected * this.kmSelected;

    let result: ServiceOffer;
    //console.log(this.customer.dealer[0].payment_method);
    console.log(years);

    console.log(this.kmSelected);
    console.log(totalKM);

    result = this.serviceoffers.find(function (offer: ServiceOffer) {
      console.log("offer");
      console.log(offer);

      return offer.years == years && offer.km == totalKM;
    });

    if (result != undefined) {
      this.service_price = result.price;
      if (this.payment_method == "split") {
        let newPrice: number;
        newPrice = result.price;

        if (this.calcStartupCost) {
          let monthsPassed = this.monthDiff(
            new Date(this.customer.firstreg),
            new Date()
          );

          //let monthsPassed = new Date(  new Date() - new Date(this.customer.firstreg) ).getMonth();
          let monthsToGo = years * 12 - monthsPassed;

          newPrice += (result.price * monthsPassed) / monthsToGo;
        }

        this.serviceaddonslist = [];
        for (var i = 0; i < this.serviceaddons.length; i++) {
          if (this.serviceaddons[i].selected) {
            newPrice += this.serviceaddons[i].price;
            //this.serviceaddonslist += this.serviceaddons[i].name + ",";
            this.serviceaddonslist.push(this.serviceaddons[i]);
          }
        }
        //this.serviceaddonslist =  this.serviceaddons.length> 0 ? this.serviceaddonslist.substring(0, this.serviceaddonslist.length - 1): "";
        this.calculatedPrice = newPrice;
      } else if (this.payment_method == "up_front") {
        let newPrice: number;

        // let monthsPassed = 13 - new Date().getMonth() - new Date(this.customer.firstreg).getMonth();
        let monthsPassed = this.monthDiff(
          new Date(this.customer.firstreg),
          new Date()
        );
        newPrice = result.price * monthsPassed;
        this.startupPrice = newPrice;
        newPrice = result.price;
        this.serviceaddonslist = [];
        for (var i = 0; i < this.serviceaddons.length; i++) {
          if (this.serviceaddons[i].selected) {
            newPrice += this.serviceaddons[i].price;
            //this.serviceaddonslist += this.serviceaddons[i].name + ",";
            this.serviceaddonslist.push(this.serviceaddons[i]);
          }
        }
        //this.serviceaddonslist =  this.serviceaddons.length> 0 ? this.serviceaddonslist.substring(0, this.serviceaddonslist.length - 1): "";

        this.calculatedPrice = newPrice;
      }
    } else {
      //alert("Kombinationen blev ikke fundet, kontakt venligst forhandleren");

      this.toasterService.pop(
        "error",
        "Error !!",
        "Kombinationen blev ikke fundet, kontakt venligst forhandleren"
      );
      this.kmSelected = Math.min.apply(Math, this.options.kmStep);
      this.yearSelected = Math.max.apply(Math, this.options.yearStep);
      this.updatePrice();
    }
  }

  monthDiff(d1, d2): number {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  //   confirmModal(template: any):void {
  // this.modalService.open(template).result.then((result) => {
  // 	if(result){
  // 		if(result=="confirm"){

  // 		    let newItem:Agreement = new Agreement();
  // 		    newItem.car = this.customer.car;
  // 		    newItem.customer = this.customer._id;
  // 		    newItem.years=this.yearSelected+'';
  // 		    newItem.km=this.kmSelected+'';
  // 		    newItem.addons = this.serviceaddonslist+'';
  // 		    newItem.price=this.calculatedPrice+'';

  // 		    this.agreementsService
  // 		        .create(newItem)
  // 		        .subscribe(
  // 		           /* happy path */ r => {
  // 		           		this.toasterService.pop('success', 'Bestilling modtaget', 'Du modtager snarest et tilbud');
  // 		           		this.hasResponded = true;
  // 		           		console.log('success');
  // 		           	},
  // 		           /* error path */ e => {this.errorMessage = e;this.isLoading = false;}
  // 		        );
  // 		}
  // 	}
  // });
  // 	}

  requestOffer(): void {
    let newItem: Partial<Agreement> = {};
    newItem.car = this.customer.car as Car;
    newItem.customer = this.customer._id;
    newItem.years = this.yearSelected + "";
    newItem.km = this.kmSelected + "";
    newItem.addons = this.serviceaddonslist;
    newItem.price = this.calculatedPrice;
    newItem.service_price = this.service_price;
    newItem.payout = this.startupPrice;

    this.agreementsService.create(newItem).subscribe(
      /* happy path */ (r) => {
        this.toasterService.pop(
          "success",
          "Bestilling modtaget",
          "Du modtager snarest et tilbud"
        );
        this.hasResponded = true;
        console.log("success");
      },
      /* error path */ (e) => {
        this.errorMessage = e;
        this.isLoading = false;
      }
    );
  }

	ngOnDestroy() {
		// prevent memory leak by unsubscribing
		this.subscription.unsubscribe();
	}
	gotoCheckout():void {

		let newItem:Agreement = new Agreement();
	    newItem.car = this.customer.car as Car;
	    newItem.customer = this.customer._id;
	    newItem.years=this.yearSelected+'';
	    newItem.km=this.kmSelected+'';
	    newItem.addons = this.serviceaddonslist;
	    newItem.price=this.calculatedPrice;
	    newItem.service_price=this.service_price;
      newItem.payout = this.startupPrice;

    var cookieOptions: CookieOptions = { path: "/", domain: '.micar.dk', sameSite: "none", } as CookieOptions; 

    /*sessionStorage.setItem('agree', JSON.stringify(newItem));*/
    this.cookieService.put('agree', JSON.stringify(newItem), cookieOptions);
	    //window.location.href='/#/checkout?cust='+this.customerid;

    top.window.location.href = "/#/checkout/" + this.customerid;

    //	    window.open('/#/checkout?cust='+this.customerid,'_blank');

    // this.agreementsService
    //        .create(newItem)
    //        .subscribe(
    //            /* happy path */ r => {console.log('success');this.isLoading = false;console.log(r);
    //            	window.location.href='/#/checkout?cust='+this.customerid;
    //        },
    //            /* error path */ e => {this.errorMessage = e;this.isLoading = false;}
    //         );
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/findcar/findcar.component.ts